import { render, staticRenderFns } from "./addOffender.vue?vue&type=template&id=0da39f16&scoped=true"
import script from "./addOffender.vue?vue&type=script&lang=js"
export * from "./addOffender.vue?vue&type=script&lang=js"
import style0 from "./addOffender.vue?vue&type=style&index=0&id=0da39f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da39f16",
  null
  
)

export default component.exports